<template>
  <v-app
    class="content-layout vertical-nav content-full"
  >
    <v-navigation-drawer
      v-model="isVerticalNavMenuActive"
      app
      data-onboarding="sidebar-main-menu"
      mini-variant-width="68"
      :expand-on-hover="menuIsVerticalNavMini"
      width="260"
      class="app-navigation-menu"
    >
      <v-list expand shaped class="vertical-nav-menu-items pt-4">
        <v-list-item
          v-for="item in navMenuItems"
          :key="item.title"
          :to="{ name: item.to }"
          class="vertical-nav-menu-link"
          active-class="bg-gradient-primary white--text"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      flat
      app
      elevate-on-scroll
      :elevation="$vuetify.theme.isDark ? 4 : 3"
      class="mx-auto app-bar-static"
      :class="{ 'px-5 app-bar-shinked': scrollY }"
    >
      <div class="navbar-content-container d-flex align-center justify-space-between" style="width: 100%; height: 100%">
        <div class="d-flex align-center">
          <v-icon
            v-if="$vuetify.breakpoint.mdAndDown"
            class="me-3"
            @click="isVerticalNavMenuActive = !isVerticalNavMenuActive"
          >
            {{ icons.mdiMenu }}
          </v-icon>
          <v-chip color="primary" class="white--text font-weight-bold px-4">
            <v-icon left small>mdi-shield-account</v-icon>
            Administrador
          </v-chip>
        </div>
        <div class="d-flex align-center">
          <app-bar-theme-switcher class="mx-4"></app-bar-theme-switcher>
          <app-bar-user-menu></app-bar-user-menu>
        </div>
      </div>
    </v-app-bar>

    <v-main>
      <div class="app-content-container mx-auto h-full">
        <slot></slot>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import { ref } from '@vue/composition-api'
import { useWindowScroll } from '@vueuse/core'
import navMenuItems from '@/navigation/manager'
import { mdiMenu } from '@mdi/js'
import AppBarThemeSwitcher from '@core/layouts/components/app-bar/AppBarThemeSwitcher.vue'
import AppBarUserMenu from '@/components/AppBarUserMenu.vue'

export default {
  components: { AppBarThemeSwitcher, AppBarUserMenu },
  data() {
    return {
      isVerticalNavMenuActive: true,
      icons: { mdiMenu },
    }
  },
  computed: {
    navMenuItems() {
      return navMenuItems
    },
    menuIsVerticalNavMini() {
      return this.$store.state.appConfig.menu?.isVerticalNavMini ?? false
    },
  },
  setup() {
    const { y: scrollY } = useWindowScroll()
    return { scrollY }
  },
}
</script>

<style lang="scss" scoped>
@import '~@core/layouts/styles/_variables';

.app-content-container {
  padding: $content-padding-vertical-navigation-menu;
}

.v-application {
  .v-app-bar {
    border-radius: 0 0 10px 10px !important;
    z-index: 5;

    &.app-bar-static {
      will-change: padding, background-color;
      transition: padding 0.2s ease, background-color 0.18s ease, left 0.3s ease;

      ::v-deep > .v-toolbar__content {
        padding: 0 24px;
      }
    }
  }

  &.content-full {
    .v-app-bar {
      max-width: unset;
      margin-left: $content-padding-vertical-navigation-menu !important;
      margin-right: $content-padding-vertical-navigation-menu !important;
    }
  }
}
</style>
